module.exports = __webpack_public_path__ + "figured-wordmark-5fab92ff919c56745a83fe2e3fad8166.webp";